import React from 'react'
import './FooterStyles.css'
import { FaEnvelope, FaFacebook, FaHome, FaLinkedin, FaPhone, FaTwitter, FaGithub } from 'react-icons/fa'
import { Link } from 'react-router-dom'

const Footer = () => {

    const email = 'example@example.com';
  const subject = 'Inquiry';
  const body = 'Hello, I have a question...';

  const handleClick = () => {
    window.location.href = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  }

  return (
    <div className='footer'>
        <div className='footer-container'>
            
            <div className='left'>
             <div className='location'>
                <div> 
                    <FaHome size={20} style={{color:'yellow' , marginTop:'4px' , marginRight:'2rem'}}/>
                </div>
                <div>
                    {/* <p style={{marginBottom:'-0.5rem'}}>
                        123, Great Apartments,
                    </p> */}
                    <h5 
                    // style={{marginBottom:'-0.5rem'}}
                    >
                        New Delhi, IN,
                    </h5>
                    <h5 
                    // style={{marginBottom:'-0.5rem'}}
                    >
                        Earth Solar System, Milkyway.
                    </h5>
                </div>                
             </div>

             <div className='phone'>
                <h4>
                    <FaPhone size={20} style={{color:'yellow', marginRight:'2rem'}}/>
                </h4>
                <div>
                    <h5> +91-8080-198-376</h5>
                </div>
             </div>
             <div className='email'>
                {/* <button onClick={handleClick}> email </button> */}
                {/* <Link to={`mailto:chinmay.g2022@gmail.com`}>Send email</Link> */}
                <a href="mailto:chinmay.g2022@gmail.com" target="_blank">
                <h4>
                <FaEnvelope size={20} style={{color:'yellow', marginRight:'2rem'}}/> 
                </h4></a>
                <div>
                <a href="mailto:chinmay.g2022@gmail.com" target="_blank">
                <h5> chinmay.g2022@gmail.com</h5> </a>
                </div>

             </div>

            </div>
            <div className='right'>
                <h4> About me</h4><br/>
                {/* <h5> This is me Chinmay Gandevikar, a frontend developer. */}
                {/* </h5> */}
                <h5>
                 I enjoy building websites with my friends like JavaScript, React, Vue, D3, Firebase, Material UI, Tailwind CSS, Bootstrap and Git. I hope your project ideas become my next challenge! </h5>
                <div className='social'>
                <h4>
                <br></br>
                <a href="http://www.linkedin.com/in/chinmay-gandevikar-98ab87134" target="_blank">   <FaLinkedin size={20} style={{color:'yellow', marginRight:'2rem'}}/> </a>
                <a href="https://github.com/EventHorizonChinmay" target="_blank">     <FaGithub size={20} style={{color:'yellow', marginRight:'2rem'}}/> </a>
                <a href="https://www.facebook.com/chinmay.gandevikar.1/" target="_blank"> <FaFacebook size={20} style={{color:'yellow', marginRight:'2rem'}}/> </a>
                {/* <a href="https://twitter.com/Entropy_Sarir" target="_blank"> <FaTwitter size={20} style={{color:'yellow', marginRight:'2rem'}}/> </a> */}
                </h4>
             </div>

            </div>
        </div>
    </div>
  )
}

export default Footer